import { ReactNode } from 'react';
import CardGroup from 'shared/containers/vxl/groups/CardGroup/CardGroup';
import { VXLSectionId } from 'shared/renderer/types';

type GroupRegistryType = {
  [key in VXLSectionId]: (props: unknown) => React.JSX.Element | ReactNode;
};

const GroupRegistry: GroupRegistryType = {
  CARD_GROUP: CardGroup,
};

export default GroupRegistry;
